import React from 'react';
import { useSelector } from 'react-redux';

import { getPhotosFromDB, getRejectedPhotosFromDB } from './selector';

import FunctionSidebarContainer from '../common/FunctionSidebar/FunctionSidebarContainer';
import ObjectPhotoComponent from './ObjectPhotoComponent';

const ObjectPhoto = () => {
  const {
    app: { baseUrl, isMobile: mobileAgent },
    user: { role: userRole },
    object: { id: objectId },
  } = useSelector((state = {}) => state);

  const aproovedPhotos = useSelector(getPhotosFromDB);
  const disaproovedPhotos = useSelector(getRejectedPhotosFromDB);

  return (
    <div className='main edit-object'>
      <div className='container-fluid'>
        <div id='object-foto'>
          <ObjectPhotoComponent
            baseUrl={baseUrl}
            isMobile={mobileAgent}
            userRole={userRole}
            objectId={objectId}
            getAproovedPhoto={getPhotosFromDB}
            getDisaproovedPhotoSelector={getRejectedPhotosFromDB}
            aproovedPhotos={aproovedPhotos}
            disaproovedPhotos={disaproovedPhotos}
          />
        </div>
      </div>
      <FunctionSidebarContainer photoWarning={true}/>
    </div>
  );
};

export default ObjectPhoto;
